import Vue from 'vue'
import Router from 'vue-router'
import Core from '@/components/Core'
import System from '@/components/System'
import Master from '@/components/Master'
import Logs from '@/components/Logs'
import Tool from '@/components/Tool'
import BroadCast from '@/components/BroadCast'
import Reports from '@/components/Reports'
import Credits from '@/components/Credits'
// import LeadMaster from '@/components/Lead/Master'
import LV2 from '@/components/V2LOYALTY_REDESIGN'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // LOYALTY V.2
    {
      path: '/mokup',
      name: 'mokup',
      component: System.mokup
    },
    {
      path: '/staff',
      name: 'staff',
      component: LV2.staff
    },
    {
      path: '/addpoint',
      name: 'addpoint',
      component: LV2.addpoint
    },
    {
      path: '/payment',
      name: 'payment',
      component: LV2.payment
    },
    {
      path: '/theme',
      name: 'theme',
      component: LV2.theme
    },
    {
      path: '/tier',
      name: 'tier',
      component: LV2.tier
    },
    {
      path: '/createBranch',
      name: 'createBranch',
      component: LV2.createBranch
    },
    {
      path: '/convertRate',
      name: 'convertRate',
      component: LV2.convertRate
    },
    {
      path: '/select/login',
      name: 'selectLogin',
      component: LV2.selectLogin
    },
    {
      path: '/login',
      name: 'login',
      component: LV2.login
    },
    {
      path: '/createShop',
      name: 'createShop',
      component: LV2.createShop
    },
    {
      path: '/createAccount',
      name: 'createAccount',
      component: LV2.createAccount
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: LV2.signUp
    },
    {
      path: '/brand',
      name: 'brand',
      component: LV2.brand
    },
    // LOYALTY V.2
    // {
    //   path: '/V2/facebookLogin',
    //   name: 'facebookLogin',
    //   component: V2.facebookLogin
    // },
    // {
    //   path: '/V2/googleLogin',
    //   name: 'googleLogin',
    //   component: V2.googleLogin
    // },
    // {
    //   path: '/V2/createaccount',
    //   name: 'createAccount',
    //   component: V2.createAccount
    // },
    // {
    //   path: '/V2/createshop',
    //   name: 'createShop',
    //   component: V2.createShop
    // },
    // {
    //   path: '/V2/signUp',
    //   name: 'signUp',
    //   component: V2.signUp
    // },
    // {
    //   path: '/V2/ver2',
    //   name: 'ver2',
    //   component: V2.ver2
    // },
    {
      path: '*',
      name: 'Login',
      component: Core.Login
    },
    {
      path: '/Master/Branch',
      name: 'Branch',
      component: Master.Branch
    },
    {
      path: '/Master/Color',
      name: 'Color',
      component: Master.Color
    },
    {
      path: '/Master/Card',
      name: 'Card',
      component: Master.Card
    },
    {
      path: '/Master/Level',
      name: 'Level',
      component: Master.Level
    },
    {
      path: '/Master/Reward',
      name: 'Reward',
      component: Master.Reward
    },
    {
      path: '/Master/ProductExchangeRate',
      name: 'ProductExchangeRate',
      component: Master.ProductExchangeRate
    },
    {
      path: '/system/fileupload',
      name: 'FileUpload',
      component: System.FileUpload
    },
    {
      path: '/system/Shop',
      name: 'Shop',
      component: System.Shop
    },
    {
      path: '/system/ListShop',
      name: 'ListShop',
      component: System.ListShop
    },
    {
      path: '/system/ListMember',
      name: 'ListMember',
      component: System.ListMember
    },
    {
      path: '/system/EditShop',
      name: 'EditShop',
      component: System.EditShop
    },
    {
      path: '/system/VgroupMapCoin',
      name: 'VgroupMapCoin',
      component: System.VgroupMapCoin
    },
    {
      path: '/system/ManageShop',
      name: 'ManageShop',
      component: System.ManageShop
    },
    {
      path: '/system/ListAllShop',
      name: 'ListAllShop',
      component: System.ListAllShop
    },
    {
      path: '/system/Errorpage',
      name: 'Errorpage',
      component: System.Errorpage
    },
    {
      path: '/Belink',
      name: 'Belink',
      component: Core.Belink
    },
    {
      path: '/Core/LoginFailed',
      name: 'LoginFailed',
      component: Core.LoginFailed
    },
    {
      path: '/Core/Login',
      name: 'Login',
      component: Core.Login
    },
    {
      path: '/Core/Home',
      name: 'Home',
      component: Core.Home
    },
    {
      path: '/Core/testHome',
      name: 'testHome',
      component: Core.testHome
    },
    {
      path: '/System/User',
      name: 'User',
      component: System.User
    },
    {
      path: '/System/UserTypeGroup',
      name: 'UserTypeGroup',
      component: System.UserTypeGroup
    },
    {
      path: '/System/Menu',
      name: 'Menu',
      component: System.Menu
    },
    {
      path: '/System/Privacy',
      name: 'Privacy',
      component: System.Privacy
    },
    {
      path: '/System/PrivacyCheck',
      name: 'PrivacyCheck',
      component: System.PrivacyCheck
    },
    {
      path: '/System/Running',
      name: 'Running',
      component: System.Running
    },
    {
      path: '/System/Token',
      name: 'Token',
      component: System.Token
    },
    {
      path: '/Logs/CRUD',
      name: 'CRUD',
      component: Logs.CRUD
    },
    {
      path: '/Logs/Auth',
      name: 'Auth',
      component: Logs.Auth
    },
    {
      path: '/Tool/Migration',
      name: 'MigrationHub',
      component: Tool.MigrationHub
    },
    {
      path: '/Tool/Migration/Funcrowd',
      name: 'FuncrowdImport',
      component: Tool.FuncrowdImport
    },
    {
      path: '/Tool/CollectQRCode',
      name: 'CollectQRCode',
      component: Tool.CollectQRCode
    },
    {
      path: '/Tool/Random',
      name: 'Random',
      component: Tool.Random
    },
    {
      path: '/Tool/Refund',
      name: 'RefundPoint',
      component: Tool.RefundPoint
    },
    {
      path: '/Tool/CollectQRCodeLot',
      name: 'CollectQRCodeLot',
      component: Tool.CollectQRCodeLot
    },
    {
      path: '/Tool/RedeemQRCode',
      name: 'RedeemQRCode',
      component: Tool.RedeemQRCode
    },
    {
      path: '/Tool/RandomCGS',
      name: 'RandomCGS',
      component: Tool.RandomCGS
    },
    {
      path: '/Tool/Activity',
      name: 'Activity',
      component: Tool.Activity
    },
    {
      path: '/Master/Editv2',
      name: 'Editv2',
      component: Master.Editv2
    },
    {
      path: '/Core/ReportActivity',
      name: 'ReportActivity',
      component: Core.ReportActivityAVG
    },
    {
      path: '/Core/PackageMain',
      name: 'PackageMain',
      component: Core.PackageMain
    },
    {
      path: '/Core/VGroupShortcuts',
      name: 'VGroupShortcuts',
      component: Core.VGroupShortcuts
    },
    {
      path: '/Tool/ReportCode',
      name: 'ReportCode',
      component: Tool.ReportCode
    },
    {
      path: '/Tool/ReportCoin',
      name: 'ReportCoin',
      component: Tool.ReportCoin
    },
    {
      path: '/System/LINEConfigSendMessage',
      name: 'LINEConfigSendMessage',
      component: System.LINEConfigSendMessage
    },
    {
      path: '/BroadCast/Audience',
      name: 'Audience',
      component: BroadCast.Audience
    },
    {
      path: '/BroadCast/BroadCast',
      name: 'BroadCast',
      component: BroadCast.BroadCast
    },
    {
      path: '/System/GivePoints',
      name: 'GivePoints',
      component: System.GivePoints
    },
    {
      path: '/Tool/GivePointM',
      name: 'GivePointM',
      component: Tool.GivePointM
    },
    {
      path: '/System/ManageApi',
      name: 'ManageApi',
      component: System.ManageApi
    },
    {
      path: '/Master/AddCoin',
      name: 'AddCoin',
      component: Master.AddCoin
    },
    {
      path: '/Master/trade',
      name: 'trade',
      component: Master.trade
    },
    {
      path: '/Master/Redeem',
      name: 'Redeem',
      component: Master.Redeem
    },
    {
      path: '/Master/Promotion',
      name: 'Promotion',
      component: Master.Promotion
    },
    {
      path: '/Master/Blog',
      name: 'Blog',
      component: Master.Blog
    },
    {
      path: '/Master/Package',
      name: 'Package',
      component: Master.Package
    },
    {
      path: '/Master/PackageQRcode',
      name: 'PackageQRcode',
      component: Master.PackageQRcode
    },
    {
      path: '/System/Transport',
      name: 'Transport',
      component: System.Transport
    },
    {
      path: '/Tool/VGroupShortcut',
      name: 'VGroupShortcut',
      component: Tool.VGroupShortcut
    },
    {
      path: '/System/friendgetfriend',
      name: 'friendgetfriend',
      component: System.friendgetfriend
    },
    {
      path: '/Reports/reportPackage',
      name: 'reportPackage',
      component: Reports.reportPackage
    },
    {
      path: '/Reports/reportFriendGetFriend',
      name: 'reportFriendGetFriend',
      component: Reports.reportFriendGetFriend
    },
    {
      path: '/System/link',
      name: 'link',
      component: System.link
    },
    {
      path: '/System/pointFree',
      name: 'pointFree',
      component: System.pointFree
    },
    {
      path: '/System/customField',
      name: 'customField',
      component: System.customField
    },
    {
      path: '/System/pay',
      name: 'pay',
      component: System.pay
    },
    {
      path: '/System/confirmPayment',
      name: 'confirmPayment',
      component: System.confirmPayment
    },
    {
      path: '/System/NotifySetting',
      name: 'NotifySetting',
      component: System.NotifySetting
    },
    {
      path: '/UpdateNotify',
      name: 'UpdateNotify',
      component: System.UpdateNotify
    },
    {
      path: '/DashBoard',
      name: 'DashBoard',
      component: Master.DashBoard
    },
    {
      path: '/Reports/reportAddPoint',
      name: 'reportAddPoint',
      component: Reports.reportAddPoint
    },
    {
      path: '/System/CreateLineOAaccount',
      name: 'CreateLineOAaccount',
      component: System.CreateLineOAaccount
    },
    {
      path: '/System/Register',
      name: 'Register',
      component: System.Register
    },
    {
      path: '/System/MigrateToV2',
      name: 'MigrateToV2',
      component: System.MigrateToV2
    },
    {
      path: '/BillingPlan',
      name: 'BillingPlan',
      component: Core.BillingPlan
    },
    {
      path: '/addcoin/slip',
      name: 'addcoin',
      component: Master.addpoint
    },
    {
      path: '/Tool/ApiReference',
      name: 'ApiReference',
      component: Tool.ApiReference
    },
    {
      path: '/Credits/Manage',
      name: 'CreditsManage',
      component: Credits.Manage
    },
    {
      path: '/System/ConnectService',
      name: 'connectService',
      component: System.connectService
    },
    {
      path: '/Master/DataMember',
      name: 'DataMember',
      component: Master.DataMemberByBarcode
    },
    {
      path: '/Reports/NotifyBirthDay',
      name: 'reportNotifyBirthDay',
      component: Reports.reportNotifyBirthDay
    },
    {
      path: '/Master/Discount',
      name: 'Discount',
      component: Master.Discount
    },
    {
      path: '/Reports/reportReceipt',
      name: 'reportReceipt',
      component: Reports.reportReceipt
    },
    {
      path: '/Core/dashboard-bvp',
      name: 'dashboar-dbvp',
      component: Core.DashboardBVP
    },
    {
      path: '/AudienceBPV',
      name: 'AudienceBPV',
      component: BroadCast.Audience
    },
    {
      path: '/Reports/reportBroadcast',
      name: 'reportBroadcast',
      component: Reports.reportBroadcast
    },
    {
      path: '/Reports/reportBirtdayPoint',
      name: 'reportBirtdayPoint',
      component: Reports.reportBirtdayPoint
    },
    {
      path: '/Reports/reportGetFriend',
      name: 'reportGetFriend',
      component: Reports.reportGetFriend
    },
    {
      path: '/Reports/reportSpecialPoin',
      name: 'reportSpecialPoin',
      component: Reports.reportSpecialPoin
    },
    {
      path: '/Reports/reportFeedbackBPV',
      name: 'reportFeedbackBPV',
      component: Reports.reportFeedbackBPV
    },
    {
      path: '/Reports/reportQRCodeLot',
      name: 'reportQRCodeLot',
      component: Reports.reportQRCodeLot
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js